// Copyright 2017 Sorama B.V.

import { Point3D, Resolution } from "datatypes/SoramaLocalApi";
import { CameraProperties, WebCamDeviceProperties } from "datatypes/SoramaWebApi";
import { CameraPropertiesCalibration } from "./CameraPropertiesCalibration";
import { FixedFovVideoCalibration } from "./FixedFovVideoCalibration";
import { IVideoCalibration } from "./IVideoCalibration";
import { WebcamDevicePropertiesCalibration } from "./WebcamDevicePropertiesCalibration";

export class VideoCalibration {
    public static create(
        position: Point3D,
        resolution: Resolution,
        distance: number,
        properties?: WebCamDeviceProperties | CameraProperties
    ): IVideoCalibration {
        if (!properties) {
            return new FixedFovVideoCalibration(position, resolution, distance, 90);
        }

        const webcamDeviceProps = properties as WebCamDeviceProperties;
        const cameraProps = properties as CameraProperties;

        if (
            webcamDeviceProps.sensorOffsetCorrectionX == undefined ||
            webcamDeviceProps.sensorOffsetCorrectionY == undefined
        ) {
            return new CameraPropertiesCalibration(position, resolution, distance, cameraProps);
        } else {
            return new WebcamDevicePropertiesCalibration(position, resolution, distance, webcamDeviceProps);
        }
    }
}
